import type { TOC } from '@ember/component/template-only'
import { array } from '@ember/helper'
import RouteTemplate from 'ember-route-template'
import { ReportingDashboardControls } from 'teacher-ui-client/components/reporting/dashboard-controls'
import { ExportType } from 'teacher-ui-client/components/reporting/export-select'
import { ReportingTeacherUiHeader } from 'teacher-ui-client/components/reporting/teacher-ui-header'
import ContentTile from 'teacher-ui-client/components/tiles/content'
import type { FastPhonicsDashboardTableRoute } from 'teacher-ui-client/reporting/ui-scope/fast-phonics/dashboard/table/route'
import { t } from 'ember-intl'
import { NoDataMessage } from 'teacher-ui-client/components/no-data-message'
import { DashboardFastPhonicsTable } from 'teacher-ui-client/components/tables/dashboard/fast-phonics'
import isSubco from 'teacher-ui-client/helpers/is-subco'

interface Signature {
  Args: {
    model: ModelFor<FastPhonicsDashboardTableRoute>
  }
}
export const FastPhonicsDashboardTablePage: TOC<Signature> = <template>
  <div class="mx-5">
    <ReportingTeacherUiHeader @title={{t "reporting.dashboardTitles.fastPhonics"}} />

    <ReportingDashboardControls
      @students={{@model.scopedStudents}}
      @routePrefix="reporting.ui-scope.fast-phonics.dashboard"
      @exportOptions={{array ExportType.CSV}}
      @isDataPresent={{Boolean @model.dashboardData}}
      @studentRouteName="reporting.ui-scope.fast-phonics.dashboard.student.table"
    />
    {{#if @model.dashboardData}}
      <ContentTile>
        <div class="max-h-192 overflow-auto print:max-h-[unset] print:overflow-visible">
          <DashboardFastPhonicsTable
            @fastPhonicsDashboardTableData={{@model.dashboardData}}
            @isSubco={{(isSubco)}}
            @students={{@model.scopedStudents}}
          />
        </div>
      </ContentTile>
    {{else}}
      <NoDataMessage />
    {{/if}}
  </div>
</template>

export default RouteTemplate(FastPhonicsDashboardTablePage)
